module.exports = __webpack_public_path__ + "img/22-12_cabrero.7a390996.jpg";